import React from "react";
import SchoolIcon from '@mui/icons-material/School';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import '../assets/styles/Education.scss';

const educationData = [
  {
    badge: "MS",
    degree: "MS (by Research) in Control and Robotics",
    institution: "IIT Palakkad",
    duration: "Jan 2026 – Present",
    icon: <AutoAwesomeIcon />,
    coursework: [
      "Mechanics and Control of Robotic Manipulators",
      "Reinforcement Learning-Based Control",
      "Foundations of Robot Autonomy",
      "Automation and Control",
      "Mobile Robots"
    ]
  },
  {
    badge: "B.E.",
    degree: "B.E. in Robotics and Automation",
    institution: "Sri Ramakrishna Engineering College (SREC), Coimbatore",
    duration: "July 2021 – Apr 2024",
    icon: <WorkspacePremiumIcon />,
    coursework: [
      "ROS Tools",
      "Mapping and Navigation",
      "Autonomous Mobile Robots",
      "Industrial Electrical Panel Design",
      "IIoT for Automation",
      "AI for Robotics",
      "Kinematics and Dynamics",
      "Python for ML",
      "Industrial Control Systems",
      "Cybersecurity"
    ]
  },
  {
    badge: "Diploma",
    degree: "Diploma in Electrical and Electronics Engineering",
    institution: "SRPTC, Coimbatore",
    duration: "Aug 2018 – Apr 2021",
    icon: <SchoolIcon />,
    coursework: [
      "Distribution and Utilization",
      "Micro Controller",
      "Digital Electronics",
      "Electrical Machines",
      "Electronic Devices and Circuits",
      "Electrical Circuit Theory"
    ]
  },
  {
    badge: "SSLC",
    degree: "SSLC (10th Standard)",
    institution: "Dr. P.G.V. Matriculation School, Coimbatore",
    duration: "2018",
    icon: <MenuBookIcon />,
    coursework: [
      "Tamil Nadu State Board",
      "Science & Mathematics",
      "General Academics"
    ]
  }
];

function Education() {
  return (
    <div className="education-container" id="education">
      <div className="items-container">
        <h1>Education</h1>
        <div className="education-grid">
          {educationData.map((item, index) => (
            <div className="education-card" key={index}>
              <div>
                <div className="education-card-header">
                  <div className="education-header-left">
                    <div className="education-icon-wrapper">
                      {item.icon}
                    </div>
                    <div>
                      <span className="education-badge">{item.badge}</span>
                      <span className="education-duration">{item.duration}</span>
                    </div>
                  </div>
                </div>

                <h2>{item.institution}</h2>
                <h3 className="education-degree">{item.degree}</h3>
              </div>

              <div className="education-coursework-section">
                <p className="coursework-title">Relevant Coursework:</p>
                <div className="education-highlights">
                  {item.coursework.map((tag, i) => (
                    <span key={i} className="education-tag">{tag}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Education;
